(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Mention", [], factory);
	else if(typeof exports === 'object')
		exports["Mention"] = factory();
	else
		root["Mention"] = factory();
})(this, function() {
return 